import { FormControl, FormHelperText, TextField } from "@mui/material";
import { FC } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { IInput, IMuiFormControl, ValidationHelpers } from "@ryde/shared";

export const TextInputByControl: FC<IMuiFormControl & IInput> = ({
  control,
  name,
  formLabel,
  formValidation,
  e2eData = "text-input",
  size = "medium",
  sx,
  inputProps,
  tabIndex,
}) => {
  const { t } = useTranslation();
  const field = t("errors.requiredField", {
    fieldName: t("general.THIS_FIELD"),
  });

  return name ? (
    <Controller
      name={name}
      control={control}
      rules={{
        required: ValidationHelpers.hasRequiredRule(formValidation) && field,
      }}
      render={({ field, fieldState: { error } }) => (
        <FormControl error={!!error}>
          <TextField
            {...field}
            label={formLabel}
            required={ValidationHelpers.hasRequiredRule(formValidation)}
            data-e2e={e2eData}
            data-e2e-field-name={name}
            sx={sx}
            size={size}
            error={!!error}
            fullWidth
            slotProps={{
              htmlInput: { ...inputProps, tabIndex },
            }}
          />
          {error && (
            <FormHelperText>
              {/*TODO: add translation solution*/}
              {error.message || t("errors.invalidFieldValue")}
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  ) : null;
};
